import { Box, Flex, Grid, Text } from '@mantine/core';
import type { FC } from 'react';
import { RestaurantsNearbyScrollArea } from './styles';
import { useGetRestaurants } from '../../services/restaurant/restaurant.service';
import { useHomeContext } from '../../context';
import RestaurantCard from './RestaurantCard';
import React, { useEffect, useRef } from 'react';
import { useMediaQuery } from '@mantine/hooks';

interface IRestaurantsNearbyProps {
  hasTrendingItems: boolean;
}

const RestaurantsNearby: FC<IRestaurantsNearbyProps> = ({ hasTrendingItems }) => {
  const mobile = useMediaQuery(`(max-width: 665px)`);
  const { selectedTagId } = useHomeContext();
  const { data, isSuccess, isLoading, isFetching, isRefetchError, hasNextPage, isFetchingNextPage, fetchNextPage } =
    useGetRestaurants({
      tagId: selectedTagId,
    });
  const scrollAreaRef = useRef<HTMLDivElement | null>(null);
  const triggerRef = useRef<HTMLDivElement | null>(null);

  const scrollHandler = async (e: any) => {
    const totalHeight = e.target.clientHeight + e.target.scrollTop;
    if (totalHeight >= e.target.scrollHeight - 50 && !isFetching && !isLoading && hasNextPage && !isRefetchError) {
      fetchNextPage();
    }
  };

  // setting observer

  useEffect(() => {
    if (!triggerRef.current || !scrollAreaRef.current || !hasNextPage) return;

    const options = {
      root: scrollAreaRef.current,
      rootMargin: '0px',
      scrollMargin: '0px',
      threshold: 0,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && hasNextPage && !isFetchingNextPage && !isLoading && !isRefetchError) {
          fetchNextPage();
        }
      });
    }, options);

    observer.observe(triggerRef.current);

    return () => observer.disconnect();
  }, [fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isRefetchError]);

  return (
    <>
      <Box mt={14} px={8}>
        <Flex direction={mobile ? 'column' : 'row'}>
          <Text fw={500} c='white'>
            RESTAURANTS&nbsp;
          </Text>
          <Text fw={500} c='white'>
            NEARBY
          </Text>
        </Flex>

        <RestaurantsNearbyScrollArea
          ref={scrollAreaRef}
          className={!hasTrendingItems ? 'without__trending__items' : 'RestaurantsNearbyScrollArea'}
          // onScroll={scrollHandler}
        >
          <Grid p={0} m={0}>
            {isSuccess && Array.isArray(data?.pages)
              ? data?.pages.map((item, index) => (
                  <React.Fragment key={index}>
                    {item?.data?.map((restaurant, index: number) => {
                      if (!restaurant?.has_menu_items) return null;
                      return (
                        <Grid.Col xs={6} key={index}>
                          <RestaurantCard
                            type='regular'
                            id={restaurant.restaurant_id}
                            imageUrl={restaurant.image_url!}
                            name={restaurant.name}
                            averageRating={restaurant.rating.average_rating}
                            averageRatingCount={restaurant.rating.count}
                            openingTime={restaurant.business_hour.opening_time ?? ''}
                            closingTime={restaurant.business_hour.closing_time ?? ''}
                            schedule={restaurant.schedule ?? ''}
                            fullAddress={restaurant.full_address}
                            restaurantOpen={restaurant.is_restaurant_open}
                            backgroundImage={restaurant?.background_image_url ?? ''}
                          />
                        </Grid.Col>
                      );
                    })}
                  </React.Fragment>
                ))
              : null}

            {hasNextPage
              ? Array(2)
                  .fill(0)
                  .map((d, index) => (
                    <Grid.Col xs={6} key={index} ref={triggerRef}>
                      <RestaurantCard type='loading' />
                    </Grid.Col>
                  ))
              : null}

            {/* {hasNextPage && <Box ref={triggerRef} h={1} w='100%' />} */}
          </Grid>
        </RestaurantsNearbyScrollArea>
      </Box>
    </>
  );
};

export default RestaurantsNearby;
